import React from "react";
import {css} from "@panda/css";

import {Radio} from "@pg-design/radio-module";

import {FilterFooter} from "../../../../search/components/filters/SearchFiltersFooter";

interface SortOption {
    label: string;
    value: number;
    slug?: string;
}

interface IOwnProps<T> {
    currentValue: T;
    setCurrentValue: (value: number) => void;
    sortOptions: SortOption[];
    onCancel: () => void;
    onSave: () => void;
}

export const SortOptions = <T,>(props: IOwnProps<T>) => {
    return (
        <div className={sortHolder}>
            <div className={sortOptionsHolder}>
                {props.sortOptions.map((sortOption) => {
                    return (
                        <Radio
                            key={sortOption.value}
                            id={sortOption.value.toString()}
                            name={sortOption.label}
                            labelContent={sortOption.label}
                            isActive={sortOption.value === props.currentValue}
                            value={sortOption.value}
                            onChange={() => {
                                props.setCurrentValue(sortOption.value);
                            }}
                        />
                    );
                })}
            </div>
            <FilterFooter onCancel={props.onCancel} onSave={props.onSave} />
        </div>
    );
};

const sortHolder = css({
    height: "calc(100vh - 6rem)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    mt: 2,
    pt: 0,
    px: 3,
    pb: 2,

    md: {
        height: "unset",
        display: "block",
        p: 0
    }
});

const sortOptionsHolder = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    flexShrink: 0,
    flexGrow: 0,

    "&> div": {
        mb: 2
    }
});
import React from "react";
import {css} from "@panda/css";

import {Radio} from "@pg-design/radio-module";

import {FilterFooter} from "../../../../search/components/filters/SearchFiltersFooter";

interface SortOption {
    label: string;
    value: number;
    slug?: string;
}

interface IOwnProps<T> {
    currentValue: T;
    setCurrentValue: (value: number) => void;
    sortOptions: SortOption[];
    onCancel: () => void;
    onSave: () => void;
}

export const SortOptions = <T,>(props: IOwnProps<T>) => {
    return (
        <div className={sortHolder}>
            <div className={sortOptionsHolder}>
                {props.sortOptions.map((sortOption) => {
                    return (
                        <Radio
                            key={sortOption.value}
                            id={sortOption.value.toString()}
                            name={sortOption.label}
                            labelContent={sortOption.label}
                            isActive={sortOption.value === props.currentValue}
                            value={sortOption.value}
                            onChange={() => {
                                props.setCurrentValue(sortOption.value);
                            }}
                        />
                    );
                })}
            </div>
            <FilterFooter onCancel={props.onCancel} onSave={props.onSave} />
        </div>
    );
};

const sortHolder = css({
    height: "calc(100vh - 6rem)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    mt: 2,
    pt: 0,
    px: 3,
    pb: 2,

    md: {
        height: "unset",
        display: "block",
        p: 0
    }
});

const sortOptionsHolder = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    flexShrink: 0,
    flexGrow: 0,

    "&> div": {
        mb: 2
    }
});
